import React, { useRef, useState } from 'react'
import { handleSingleFileUpload } from '../../../helper/imageSingalHelper';
import { Formik, Form, Field } from 'formik';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Label, Row } from 'reactstrap';
import { DeleteSvg, FileIconSvg, SaveSvg } from '../../../components/CommonSvg';
import SimpleReactValidator from "simple-react-validator";
import { __t } from '../../../i18n/translator';
import { getFileNameFromURL } from '../../../utils/generalUtils';
import { size } from 'lodash';

export default function AddEditSupportDetails({ addSupportDetailsRequest, isEdit, dispatch, tab }) {
  const validator = useRef(new SimpleReactValidator());
  const [imageFile, setImageFile] = useState(isEdit?.imagePath ? getFileNameFromURL(isEdit.imagePath) : null);
  const [imageFileData, setImageFileData] = useState(isEdit?.imagePath ? { imageUrl: isEdit.imagePath, fileNames: getFileNameFromURL(isEdit.imagePath) } : null);
  const initialValues = isEdit ? { ...isEdit, imageFile: isEdit.imagePath } : {
    serviceName: "",
    contactNumber: "",
    alternateNumber: "",
    name: "",
    emailId: "",
    imageFile: null,
    extention: ""
  };
  console.log(isEdit, "isEditisEdit")
  const handleSubmit = async (values) => {
    if (validator.current.allValid()) {
      const formData = new FormData();
      if (values.id) {
        formData.append('id', values.id);
      }
      if (values.supportType === "Representative") {
        formData.append('alternateNumber', "");
        formData.append('serviceName', "");
        formData.append('extention', values.extention || '');
      }
      if (values.supportType === "Service") {
        formData.append('extention', '');
        formData.append('serviceName', values.serviceName);
        formData.append('alternateNumber', values.alternateNumber || '');
      }
      formData.append('contactNumber', values.contactNumber);
      formData.append('userName', values.userName);
      formData.append('emailId', values.emailId);
      if (values.imageFile) {
        formData.append('imageFile', imageFile);
      } else {
        formData.append('imageFile', null);

      }
      formData.append('supportType', values.supportType === "Service" ? 1 : 0)
      addSupportDetailsRequest({ value: formData, dispatch: dispatch })
    } else {
      validator.current.showMessages();
    }
  };
  return (
    <>
      <Formik
        initialValues={{ ...initialValues, supportType: tab }}
        // validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, errors, touched }) => (
          <Form>
            <Row>
              <Col className='mb-2' sm={12} md={12} lg={12} xl={12}>
                <FormGroup className='mb-2'>
                  <Field
                    id="userName"
                    name="userName"
                    placeholder="Name"
                    className="form-control"
                    type="text"
                  />
                  <Label className="form-label" htmlFor="userName">
                    Name <span className="text-danger">*</span>
                  </Label>
                  {validator.current.message(
                    __t("validations.supportDetails.name"),
                    values.userName,
                    "required|alpha_space",
                    {
                      messages: {
                        required: __t("validations.supportDetails.name"),
                      },
                    }
                  )}
                </FormGroup>
              </Col>
              <Col sm={values.supportType !== "Service" ? 6 : 4} className='mb-2'>
                <FormGroup className='mb-2'>
                  <Field
                    id="emailId"
                    name="emailId"
                    placeholder="Email Address"
                    className="form-control"
                    type="email"
                  />
                  <Label className="form-label" htmlFor="emailId">
                    Email Address <span className="text-danger">*</span>
                  </Label>
                  {validator.current.message(
                    __t("validations.supportDetails.emailId"),
                    values.emailId,
                    "required|email",
                    {
                      messages: {
                        required: __t("validations.supportDetails.emailId"),
                      },
                    }
                  )}
                </FormGroup>
              </Col>
              <Col sm={values.supportType !== "Service" ? 6 : 4} className='mb-2'>
                <FormGroup className='mb-2'>
                  <Field
                    id="contactNumber"
                    name="contactNumber"
                    placeholder="Contact Number"
                    className="form-control"
                    type="text"
                    maxLength={20}
                    onChange={(e) => {
                      const formatted = e.target.value.replace(/[^0-9-]/g, '');
                      setFieldValue("contactNumber", formatted);
                    }}
                  />
                  <Label className="form-label" htmlFor="contactNumber">
                    Contact Number <span className="text-danger">*</span>
                  </Label>
                  {validator.current.message(
                    __t("validations.supportDetails.contactNumber"),
                    values.contactNumber,
                    "required|regex:^[0-9\\-]+$",
                    {
                      messages: {
                        required: __t("validations.supportDetails.contactNumber"),
                      },
                    }
                  )}

                </FormGroup>
              </Col>
              {values.supportType === "Service" && <>
                <Col sm={4} className='mb-2'>
                  <FormGroup>
                    <Field
                      id="alternateNumber"
                      name="alternateNumber"
                      placeholder="Alternate Number"
                      className="form-control"
                      type="text"
                      maxLength={10}
                    />
                    <Label className="form-label" htmlFor="alternateNumber">
                      Alternate Number
                    </Label>
                  </FormGroup>
                </Col>
              </>}
              <Col className='mb-2 align-items-center d-flex' sm={values.supportType === "Service" ? 5 : 6}>
                <FormGroup className='d-flex gap-2 mb-0'>
                  <Label className="form-label mb-0 position-sticky" style={{ display: 'Block' }} htmlFor="supportType" >
                    Support Type
                  </Label >
                  {/* <div>
                      <div className="form-check form-check-inline">
                        <Field
                          type="radio"
                          name="supportType"
                          value="Representative"
                          className="form-check-input"
                          id="supportTypeRepresentative"
                          onClick={() => {
                            setFieldValue('extention', null);
                            validator.current.purgeFields('extention');
                          }}
                        />
                        <label
                          // className="form-check-label"
                          htmlFor="supportTypeRepresentative"
                        >
                          Representative
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Field
                          type="radio"
                          name="supportType"
                          value="Service"
                          className="form-check-input"
                          id="supportTypeService"
                          onClick={() => {
                            setFieldValue('serviceName', null);
                            setFieldValue('alternateNumber', null);
                            validator.current.purgeFields();
                          }}
                        />
                        <label
                          // className="form-check-label"
                          htmlFor="supportTypeService">
                          Service
                        </label>
                      </div>
                    </div> */}
                  <div className='d-flex gap-1'>
                    <Button
                      color={values.supportType === 'Representative' ? 'primary' : 'secondary'}
                      size={'sm'}

                      onClick={() => {
                        setFieldValue('extention', null);
                        validator.current.purgeFields();
                        setFieldValue('supportType', 'Representative')
                      }}
                      active={values.supportType === 'Representative'}
                      style={{ transform: 'translateY(0rem)', fontWeight: "600" }}
                    >
                      Representative
                    </Button>
                    <Button
                      color={values.supportType === 'Service' ? 'primary' : 'secondary'}
                      size={'sm'}
                      onClick={() => {
                        setFieldValue('serviceName', null);
                        setFieldValue('alternateNumber', null);
                        setFieldValue('supportType', 'Service');
                        validator.current.purgeFields();
                      }}
                      active={values.supportType === 'Service'}
                      style={{ transform: 'translateY(0rem)', fontWeight: "600" }}

                    >
                      Service
                    </Button></div>
                </FormGroup>
                {validator.current.message(
                  __t("validations.supportDetails.supportType"),
                  values.supportType,
                  "required",
                  {
                    messages: {
                      required: __t("validations.supportDetails.supportType"),
                    },
                  }
                )}
              </Col>
              {values.supportType === "Service" && <Col sm={7}>
                <FormGroup>
                  <Field
                    id="serviceName"
                    name="serviceName"
                    placeholder="Service Name"
                    className="form-control"
                    type="text"
                  />
                  <Label className="form-label" htmlFor="serviceName">
                    Service Name <span className="text-danger">*</span>
                  </Label>

                  {validator.current.message(
                    __t("validations.supportDetails.serviceName"),
                    values.serviceName,
                    "required",
                    {
                      messages: {
                        required: __t("validations.supportDetails.serviceName"),
                      },
                    }
                  )}
                </FormGroup>
              </Col>}
              {values.supportType === "Representative" && <Col sm={12} md={6} lg={6} xl={6}>
                <FormGroup>
                  <Field
                    id="extention"
                    name="extention"
                    placeholder="Extention"
                    className="form-control"
                    type="number"
                  />
                  <Label className="form-label" htmlFor="extention">
                    Extention <span className="text-danger">*</span>
                  </Label>
                  {validator.current.message(
                    __t("validations.supportDetails.extension"),
                    values.extention,
                    "required|numeric",
                    {
                      messages: {
                        required: __t("validations.supportDetails.extension"),
                        numeric: 'Please enter numeric value',
                      },
                    }
                  )}
                </FormGroup>
              </Col>}
              <Col md={12} lg={12} className='mb-3'>
                <Label className="form-label " style={{ display: 'contents' }} htmlFor="imageFile" >
                  Upload Image
                </Label >

                <div className="image_upload">
                  {!imageFileData ? (
                    <div className="dropzone">
                      <label htmlFor="imageFile" className="dropzone-container">
                        <div className="file-icon">
                          <FileIconSvg />
                        </div>
                        <div className="dropzone-title">
                          Drag and drop your files or{" "}
                          <span className="browse d-inline-block text-center">browse</span>{" "}
                          your files
                        </div>
                        <input
                          id="imageFile"
                          name="imageFile"
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={(e) =>
                            handleSingleFileUpload(
                              setImageFile,
                              setFieldValue,
                              "imageFile",
                              setImageFileData,
                              e
                            )
                          }
                        />
                      </label>
                    </div>
                  ) : (
                    <div className='support_details_image_upload'>
                      {imageFileData && (
                        <>
                          <a
                            onClick={() => {
                              setImageFile(null);
                              setImageFileData(null);
                              setFieldValue("imageFile", null);
                            }}
                            className="remove-box"
                            title="remove"
                          >
                            <DeleteSvg />
                          </a>
                          {/*    <button
                    className="btn btn-primary delete_document"
                    title="Delete Image"
                    onClick={() => {
                      setImageFile(null);
                      setImageFileData(null);
                      setFieldValue("imageFile", null);
                    }}
                    type="button"
                  >
                    <DeleteSvg /> Delete
                  </button> */}
                        </>
                      )}
                      <img
                        src={imageFileData.imageUrl}
                        alt={imageFileData.fileNames}
                      // style={{ maxWidth: "94px", height: "auto" }}
                      />
                    </div>
                  )}

                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={12} lg={3}>
                <Button
                  type="submit"
                  color="success"
                  className="w-auto mx-auto d-flex align-items-center gap-2 lh-base mb-3"
                  title="Submit"
                >
                  <SaveSvg /> Submit
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}
